import { render, staticRenderFns } from "./MatomoParams.vue?vue&type=template&id=ad4f959e&"
import script from "./MatomoParams.vue?vue&type=script&lang=js&"
export * from "./MatomoParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports